import type { ExpeditorProfileDto, ExpeditorProfileInput } from '@expeditor/shared';
import { apiClient } from './client';

export const expeditorProfileApi = {
  async get(): Promise<ExpeditorProfileDto> {
    const { data } = await apiClient.get<ExpeditorProfileDto>('/expeditor-profile');
    return data;
  },
  async update(dto: ExpeditorProfileInput): Promise<ExpeditorProfileDto> {
    const { data } = await apiClient.put<ExpeditorProfileDto>('/expeditor-profile', dto);
    return data;
  },
  /** Публичная инфа для лендинга (без аутентификации). */
  async getPublicName(): Promise<{ name: string | null }> {
    const { data } = await apiClient.get<{ name: string | null }>('/expeditor-profile/public');
    return data;
  },
};
